import React from 'react';
import '../styles/TechnicalConsultingSection.css';
// Importiere das Bild direkt
import technicalComponent from '../assets/technical-component.png';

const TechnicalConsultingSection = () => {
  return (
    <section className="technical-consulting">
      <div className="consulting-container">
        <div className="consulting-text">
          <h2>Fachwissen für<br />Praxis und Ausbildung</h2>
          <p>
Wir beraten zu technischen Fragestellungen im Bereich Sanitär-, Heizungs- und Klimatechnik (SHK). Zu unseren Tätigkeiten gehören Schadenanalysen und Gutachten. 
          </p>
                    <p>
Des Weiteren umfasst unsere Arbeit die Erstellung technischer Illustrationen sowie die Unterstützung von Ausbildungsbetrieben.
          </p>
        </div>
        <div className="consulting-image">
          <img
            src={technicalComponent}
            alt="Technische Komponente – Ventil oder Armatur"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default TechnicalConsultingSection;
